// ISO 4217 currency codes (3-letter codes): Add more if/when needed?
export enum CurrencyCode {
	UNITED_STATES = 'USD',
	CANADA = 'CAD'
}
